import { connect } from 'react-redux';
import Panel from './panel'
import * as AC from '../../actions/actionCreators'
import { getSetting } from '../../util/helpers'

function mapStateToProps(state) { 
	return {
        visitorTerritory: state.profile.visitorTerritory,
        role: state.user.role,
        isLoading: state.panel.isLoading,
        isSaving: state.request.isLoading,
        actualPanel: state.panel.actualPanel,
        panelForExport: state.panel.panelForExport,
        errorPanelChange: state.panelChange.error,
        errorPanel: state.panel.error,
        isPanelOpen: getSetting(state.setting.settings, "isPanelOpen") === "true",
        isSettingsLoaded: state.setting.settings.length > 0
}};

function mapDispatchToProps(dispatch) {
    return({
        fetchPanel: (visitorTerritory) => { dispatch(AC.PanelLoadingStarted(visitorTerritory) ) },
        fetchPanelForExport: (visitorTerritory) => { dispatch(AC.PanelForExportLoadingStarted(visitorTerritory) ) },
        fetchSettings: () => { dispatch(AC.SettingLoadingStarted() ) },
        panelChangeRemoveTarget: (license, visitorTerritory) => { dispatch(AC.PanelChangeRemoveTargetStarted(license, visitorTerritory) ) },
        clearPanelUi: () => { dispatch(AC.ClearPanelUi()) },
        clearPanelChangeUi: () => { dispatch(AC.ClearPanelChangeUi()) },
        clearRequestUi: () => { dispatch(AC.ClearRequestUi()) }
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(Panel);